<div class="contPop1">
    <h2 mat-dialog-title class="md-title chat-cont-a">
        <label class='labTitle chatTitle-b'>Guía de Canales {{this.planName}}</label>
        <div (click)="this.close('cancel');" class="selected">
            X
        </div>
    </h2>
    <div class="main-container">
        <div *ngIf="this.allChannels.length!=0" class="channel-container">
            <div *ngFor="let channel of this.allChannels; let j = index">
                <div class="channel-box">
                    <img class="img-box" src="{{(channel.url).replace('img','images')}}">
                </div>
            </div>
        </div>
        <div class="empty" *ngIf="this.allChannels.length==0">
            No hay listas disponibles.
        </div>
    </div>
</div>
